import React from "react";
import { Layout, GovernanceTokenCom } from "../components";

const GovernanceTokenPage = () => {
  return (
    <>
      <Layout>
        <GovernanceTokenCom />
      </Layout>
    </>
  );
};

export default GovernanceTokenPage;
